
import { Component, Prop, Vue } from 'vue-property-decorator'
import { ReturnedProductSet } from './types'

@Component
export default class ReturnedProductSets extends Vue {
  @Prop() returnedProductSets!: ReturnedProductSet[]

  totalPrice(prices: (number | null)[]) {
    return prices.reduce((x, y) => (x ?? 0) + (y ?? 0), 0)
  }
}
